import React, { useEffect } from 'react';
import TickIcon from '../../assets/icons/check.svg';
import AlertIcon from '../../assets/icons/alert.svg';

const Notification = ({ open, onClose, type, message, timeout }) => {
    useEffect(() => {
        if (open && timeout > 0) {
            setTimeout(onClose, timeout);
        }
    }, [open, onClose, timeout]);

    return open ? (
        <div
            className={`flex justifyCenter alignCenter ${type}`}
            style={{
                padding: '20px 12px 10px',
                position: 'fixed',
                bottom: 0,
                left: 0,
                width: 'calc(100% - 320px)',
                zIndex: 100,
            }}
        >
            <img
                src={type === 'success-toast' ? TickIcon : AlertIcon}
                alt='notification-icon'
                height={24}
                width={24}
            />
            <p
                style={{
                    textAlign: 'center',
                    fontSize: 20,
                    lineHeight: 1.4,
                    color: '#ffffff',
                    margin: '0px 24px',
                }}
            >
                {message}
            </p>
        </div>
    ) : null;
};

export default Notification;
